import { render, staticRenderFns } from "./PublishAgent.vue?vue&type=template&id=588613b8&scoped=true"
import script from "./PublishAgent.vue?vue&type=script&lang=js"
export * from "./PublishAgent.vue?vue&type=script&lang=js"
import style0 from "./PublishAgent.vue?vue&type=style&index=0&id=588613b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588613b8",
  null
  
)

export default component.exports